import { isFeatureEnabled } from 'owa-feature-flags';
import isInConversationView from './isInConversationView';

export function isSubjectPickerSupported(): boolean {
    return isSubjectPickerOnFocusFlightEnabled() || isSubjectPickerButtonFlightEnabled();
}

export function isSubjectPickerOnFocusFlightEnabled(): boolean {
    return isFeatureEnabled('peo-subjectPicker') && isInConversationView();
}

export function isSubjectPickerButtonFlightEnabled(): boolean {
    return isFeatureEnabled('peo-subjectPickerButton') && isInConversationView();
}

export function isSubjectPickerControlSupported(): boolean {
    return isFeatureEnabled('peo-subjectPickerControl') && isInConversationView();
}
